import { MutationTree } from 'vuex';
import { TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setCustomTemplates:(state, data) => {
        state.customTemplates = data
    },

    setCustomMultichannelTemplates:(state, data) => {
        state.customMultichannelTemplates = data
    },

    setCustomTemplateItem:(state, data) => {
        state.customTemplateItem = data
    },
};
